import axios from 'axios'

export const getAllTags = (params) => {
  let remoteUrl = 'tags'

  return axios.get(remoteUrl, {params: params})
}

export const getTag = (id, params) => {
  let remoteUrl = 'tags/' + id

  return axios.get(remoteUrl, {params: params})
}

export const addTag = (data) => {
  let remoteUrl = 'tags'
  return axios.post(remoteUrl, data)
}

export const editTag = (id, data) => {
  let remoteUrl = 'tags/' + id
  return axios.put(remoteUrl, data)
}

export const deleteTag = (id) => {
  let remoteUrl = 'tags/' + id
  return axios.delete(remoteUrl)
}



// WEBPACK FOOTER //
// ./src/api/tags.js